var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white customBorderWrapper p-6 pb-3" },
    [
      _vm.isAdmin
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-col mb-10 font-normal text-lg text-primary-black items-baseline flex",
            },
            [
              _c(
                "p",
                {
                  staticClass:
                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg normal-case w-35 text-primary-black",
                },
                [_vm._v(" Visit Based Clock-Ins ")]
              ),
              _c(
                "div",
                { staticClass: "font-normal text-base text-storm-gray" },
                [_vm._v(" " + _vm._s(_vm.allowClokcin) + " ")]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass:
            "flex flex-col mb-10 font-normal text-lg text-primary-black items-baseline flex",
        },
        [
          _c(
            "p",
            {
              staticClass:
                "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg normal-case w-35 text-primary-black",
            },
            [_vm._v(" Special Instructions ")]
          ),
          _vm.specialInstructions
            ? _c("FormattedDescription", {
                staticClass: "font-normal text-base text-storm-gray",
                attrs: { content: _vm.specialInstructions },
              })
            : _c(
                "span",
                { staticClass: "font-normal text-base text-storm-gray" },
                [_vm._v(" No special instructions added. ")]
              ),
        ],
        1
      ),
      _vm.isAdmin
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-col mb-10 font-normal text-lg text-primary-black items-baseline flex",
            },
            [
              _c(
                "p",
                {
                  staticClass:
                    "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg normal-case w-35 text-primary-black",
                },
                [_vm._v(" Access Information ")]
              ),
              _c("div", { staticClass: "mb-4" }, [
                _c(
                  "p",
                  { staticClass: "font-normal text-base text-dark-gray" },
                  [_vm._v("Access Type")]
                ),
                _c(
                  "div",
                  { staticClass: "font-normal text-base text-dark-gray" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(this.project.access_type || "Not added.") +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", [
                _c(
                  "p",
                  { staticClass: "font-normal text-base text-dark-gray" },
                  [_vm._v("Code")]
                ),
                _c(
                  "div",
                  { staticClass: "font-normal text-base text-dark-gray" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(this.project.access_number || "Not added.") +
                        " "
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isAdmin && _vm.projectContarctors
        ? _c(
            "div",
            {
              staticClass:
                "flex flex-col mb-10 font-normal text-lg text-primary-black items-baseline flex",
            },
            [
              _c("div", { staticClass: "flex flex-row" }, [
                _c(
                  "p",
                  {
                    staticClass:
                      "flex font-400 labelWidth leading-6 mb-4 text-primary-black text-lg normal-case w-35 text-primary-black",
                  },
                  [_vm._v(" Number of Resources ")]
                ),
                _vm.projectContarctors.length > 0
                  ? _c("p", { staticClass: "totalNumber ml-0.5" }, [
                      _vm._v(
                        " (" + _vm._s(_vm.projectContarctors.length) + ") "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm.projectContarctors && _vm.projectContarctors.length > 0
                ? _c(
                    "div",
                    { staticClass: "flex flex-row gap-4" },
                    _vm._l(_vm.projectContarctors, function (res) {
                      return _c(
                        "div",
                        { key: res.id },
                        [
                          _c(
                            "RouterLink",
                            { attrs: { to: _vm.getContactorLink(res) } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-nav-gray text-lg avatarPading font-normal rounded-full block border border-gray-300 bg-white borderCard hover:text-primary-500 hover:border-primary-500",
                                },
                                [
                                  res.user
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-row items-center",
                                          attrs: {
                                            name: "imageAvatar",
                                            image: res.user.avatar,
                                          },
                                        },
                                        [
                                          res.user.avatar !== null
                                            ? _c("S3Image", {
                                                class: [
                                                  _vm.defaultImageClasses,
                                                ],
                                                attrs: {
                                                  s3FileKey: res.user.avatar,
                                                },
                                              })
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-xs leading-none font-semibold mr-1",
                                                  class: _vm.getAvatrClass,
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        res.user.given_name
                                                          .trimStart()[0]
                                                          .toUpperCase()
                                                      ) +
                                                      _vm._s(
                                                        res.user.family_name
                                                          .trimStart()[0]
                                                          .toUpperCase()
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "text-nav-gray chipText font-normal",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(res.user.given_name) +
                                                  " " +
                                                  _vm._s(res.user.family_name) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _c(
                    "span",
                    { staticClass: "font-normal text-base text-storm-gray" },
                    [_vm._v(" No resources added. ")]
                  ),
            ]
          )
        : _vm._e(),
      _vm.isAdmin
        ? _c(
            "CardBodyItem",
            {
              staticClass: "font-normal text-lg text-primary-black",
              attrs: { label: "Tags", totalNumber: _vm.projectTags.length },
            },
            [
              _vm.projectTags.length > 0
                ? _c("ItemChipsWithMore", {
                    attrs: {
                      items: _vm.projectTags,
                      textClasses: "chipCustomText",
                      limit: 100,
                    },
                  })
                : _c(
                    "span",
                    { staticClass: "font-normal text-base text-storm-gray" },
                    [_vm._v(" No tags added. ")]
                  ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }